import { message } from 'antd';
import { CONTACT_ID_FROM_LANDING_PAGE } from 'containers/LandingPage/FarmToTablePage/saga';
import { call, fork, put, take } from 'redux-saga/effects';
import { checkValidEmail, contactUs } from 'utils/apollo';
import { clearReferralParams, getReferralParam } from 'utils/referralUtils';
import { triggerGA4SignUpEvent } from 'utils/triggerGA4Event';
import { checkEmail as checkEmailActions, contactUs as contactUsActions } from './actions';
import ActionTypes from './constants';

function* contactUsFlow() {
  while (true) {
    const { payload } = yield take(ActionTypes.CONTACT_US_SUBMIT);
    payload.lang = localStorage.getItem('lang') || 'vi';
    yield put(contactUsActions.request());
    const bePayload = {
      ...payload,
      refCode: getReferralParam('REF') || '',
      utmSource: getReferralParam('UTM_SOURCE') || '',
      utmMedium: getReferralParam('UTM_MEDIUM') || '',
      utmCampaign: getReferralParam('UTM_CAMPAIGN') || '',
      crmAcqType: getReferralParam('CRM_ACQ_TYPE') || '',
      crmSourceType: getReferralParam('CRM_SOURCE_TYPE') || '',
    };
    const response = yield call(contactUs, { input: bePayload });

    if (!response.errors) {
      const ga4Payload = {
        ...payload,
        customerContactRequestId: response.customerContactRequestId,
      };

      triggerGA4SignUpEvent(ga4Payload);
      yield put(contactUsActions.success(ga4Payload));
      if (window.localStorage.getItem(CONTACT_ID_FROM_LANDING_PAGE)) {
        window.localStorage.removeItem(CONTACT_ID_FROM_LANDING_PAGE);
      }
      clearReferralParams();
      sessionStorage.removeItem('referralCode');
    } else {
      yield put(contactUsActions.failure(response.errors));
      response.errors.map((e: any) => message.error(e.message));
    }
  }
}

function* checkEmailFlow() {
  while (true) {
    const { payload } = yield take(ActionTypes.CHECK_EMAIL_SUBMIT);
    yield put(checkEmailActions.request());
    const response = yield call(checkValidEmail, { email: payload });
    if (!response.errors) {
      yield put(checkEmailActions.success(response));
    } else {
      yield put(checkEmailActions.failure(response.errors[0].message));
    }
  }
}

export default function* contactUsPageSaga() {
  yield fork(contactUsFlow);
  yield fork(checkEmailFlow);
}
